import { useState, useEffect, useContext, useRef } from "react";
import "../customModelPop.css";


const CustomClosePopup = () => {
    
    const [isModalVisible, setIsModalVisible] = useState(false);
    const headerRef = useRef<HTMLDivElement | null>(null); 
  
    const handleCloseModalClick = () => {
      sessionStorage.setItem("modalClosed", "true");
      setIsModalVisible(false);
    };
  
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
        console.log(e);
      if (!sessionStorage.getItem("modalClosed")) {
        e.preventDefault();
        setIsModalVisible(true);
        e.returnValue = "";
      }
    };
  
    useEffect(() => {
      if (!sessionStorage.getItem("modalClosed")) {
        // window.addEventListener("beforeunload", handleBeforeUnload);
      }
  
      return () => {
        // window.removeEventListener("beforeunload", handleBeforeUnload);
      };
    }, []);

    // const handleMouseMove = (e: MouseEvent) => {
    //   const threshold = 30;
    //   if (e.clientY < threshold) {
    //     setIsModalVisible(true);
    //     sessionStorage.removeItem("modalClosed");
    //   }
    // };

    const handleMouseMove = (e: MouseEvent) => {
      const threshold = 10;
      const headerHeight = headerRef.current?.offsetHeight || 0;
      if (e.clientY < threshold && e.clientY > headerHeight) {
        setIsModalVisible(true);
        sessionStorage.removeItem("modalClosed");
      }
    };
  
    // Trigger when the mouse leaves the browser window (mouseleave event)
    const handleMouseLeave = () => {
      if (!sessionStorage.getItem("modalClosed")) {
        setIsModalVisible(true);
        sessionStorage.removeItem("modalClosed");
      }
    };
  
    // useEffect(() => {
    //   window.addEventListener("mousemove", handleMouseMove);

    //   return () => {
    //     window.removeEventListener("mousemove", handleMouseMove);
    //   };
    // }, []);

    //  useEffect(() => {
    //   const intervalId = setInterval(() => {
    //     const modalCheckAdd = sessionStorage.getItem("modalCheckAdd");
    //     if (modalCheckAdd) {
    //       window.addEventListener("mousemove", handleMouseMove);
    //     } else {
    //       window.removeEventListener("mousemove", handleMouseMove);
    //     }
    //   }, 1000);

    //   return () => {
    //     clearInterval(intervalId);
    //     window.removeEventListener("mousemove", handleMouseMove);
    //   };
    // }, []);
    return (
      <div>
        {isModalVisible && (
          <div className="modal-overlay z-10">
            <div className="modal-container">
              {/* Close Button */}
              <button className="close-btn" onClick={handleCloseModalClick}>
                &times;
              </button>
  
              {/* Icon */}
              <div className="icon-box">
                <img src="/form-enph/Calendar.png" alt="calendar icon" className="w-10 h-10" />
              </div>
  
              {/* Title */}
              <h3 className="text-xl font-semibold text-gray-800">
                Not sure about solar? Get expert advice.
              </h3>
  
              {/* Description */}
              <p className="text-gray-600 mt-2 text-sm">
                Our solar experts will guide you through the process. No pressure and absolutely no obligations. Book your complimentary review today!
              </p>
  
              {/* Button */}
              <button
                className="book-btn"
                onClick={(e) => {
                  e.preventDefault();
                  handleCloseModalClick();
                  sessionStorage.setItem('calendlyPopupClosed', 'true');
                }}
              >
                Talk to an expert 
              </button>
              <button
                className="book-btn bg-white text-black"
                onClick={(e) => {
                  e.preventDefault();
                  handleCloseModalClick();
                  sessionStorage.setItem('callPopupClosed', 'true');
                }}
              >
                Call now: (510) 945-6752
              </button>
            </div>
          </div>
        )}
      </div>
    );
  };
  
  export default CustomClosePopup;
  
